@use "Styles/includes/variables";
@use "Styles/mixins";

:host {
    display: inline-flex;
}

.vm-video-save-menu {
    &__form-header {
        display: inline-block;
        padding: 32px 16px 0;
        font-size: 20px;
        line-height: 30px;
        font-weight: 900;
    }

    &__form {
        display: flex;
        flex-direction: column;
        height: 100%;
        gap: 16px;
        margin: 32px 0 0;
    }

    &__form-label {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    &__form-label-text {
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
    }

    &__form-error {
        font-size: 14px;
        line-height: 20px;
        color: mixins.get-color(text, text-error-primary);
    }

    &__form input,
    &__form textarea {
        box-sizing: border-box;
        width: 100%;
        padding: 12px 14px;
        border: none;
        border-radius: 6px;
        background-color: mixins.get-color(background, bg-gray-100);
        font: inherit;
        outline: none;

        &.has-error {
            border: 1px solid mixins.get-color(border, border-error-subtle);

            &:focus {
                border: 1px solid mixins.get-color(border, border-error);
            }
        }

        &::placeholder {
            color: mixins.get-color(text, text-placeholder);
        }
    }

    &__form textarea {
        resize: vertical;
        min-height: 80px;
    }

    &__form-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 24px 16px 16px;
        margin: auto -16px 0;
        box-shadow:
            0 -4px 6px -2px rgba(10, 13, 18, 0.03),
            0 -2px 2px -1px rgba(10, 13, 18, 0.04);

        @include mixins.desktop-and-up {
            padding: 24px 32px 0;
            margin: 32px -32px 0;
        }
    }
}
